import { ListCompanyPixelsRO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";
import { FetchDataParamsWithToken } from "types";
import { CompanyPixel } from "@intentsify/types";

const listCompanyPixels = async (
  companyId: number,
  params: FetchDataParamsWithToken<keyof CompanyPixel>
): Promise<ListCompanyPixelsRO> => {
  const { data } = await apiService.get<ListCompanyPixelsRO>(
    Endpoints.Companies.Get.ListPixels(companyId),
    { params }
  );

  return data;
};

export { listCompanyPixels };
